var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.415 10.438a.9.9 0 0 1 0 1.79l-.092.005h-.005a.9.9 0 0 1 0-1.8h.005zM8.318 3.917a2.417 2.417 0 0 1 1.365 4.411c-.207.142-.377.28-.49.416-.109.132-.125.213-.125.256a.75.75 0 0 1-1.5 0c0-.509.226-.918.472-1.215.244-.293.545-.524.794-.694a.915.915 0 0 0-.516-1.674.92.92 0 0 0-.917.917.75.75 0 0 1-1.5 0 2.42 2.42 0 0 1 2.417-2.417"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.318.583a7.417 7.417 0 1 1-.002 14.834A7.417 7.417 0 0 1 8.318.583m0 1.5a5.917 5.917 0 1 0 0 11.832 5.917 5.917 0 0 0 0-11.832",
    clipRule: "evenodd"
  })));
};
export default Svg16;